import RedebitPaymentStatusListResultModelBase from '../_generated/modelBases/redebit-payment-status-list-result-model-base';

export default class RedebitPaymentStatusListResultModel extends RedebitPaymentStatusListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
